import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BillingStrategy, promoCodesRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const usePromoValidation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: promoCodesRepo.getPromoCodesValidation,
    mutationKey: [QueryKeys.PROMO_VALIDATION],
    onSuccess: (data, query) => {
      if (query.billingStrategy === BillingStrategy.Stripe && data.success && data.rating) {
        queryClient.setQueryData([QueryKeys.RATING, query.ratingRequest.toJson()], data.rating);
      }
    },
  });

  return useMutationMemoized(mutation);
};

export type UsePromoValidation = ReturnType<typeof usePromoValidation>;
